var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 9,
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 9,
    fill: "#D9D9D9",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M12.669 17.743a1 1 0 0 1-1.338 0C9.111 15.746 8 13.75 8 11.752 8 9.68 9.79 8 12 8s4 1.68 4 3.752c0 1.997-1.11 3.994-3.331 5.991zM12 13.003a1.5 1.5 0 1 0-.001-3 1.5 1.5 0 0 0 .001 3z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 18.175,
    y: 3.052,
    fill: "#D9D9D9",
    rx: 1,
    transform: "rotate(40 20.175 4.052)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.403bcf6dba5843da2d8b17f5a953cb45.svg";
export { ForwardRef as ReactComponent };